module.exports = {
  key: {
    select_status: 0, // 是否选择表单，1是0否，否代表选择自己
    form_model: null, // 所选表单
    title_config: '', // 内容显示字段名称
    // form_name: [], // 内容显示名称
    filter: '', // 筛选条件
    has_search: 0, // 是否有搜索 1是0否
    type: 10, // 类型，10下拉20
    is_link: 0, // 是否级联方式
    link_pid: null, // 级联关联字段选择
    has_null: 0 // 是否可以选无
  }
}



// WEBPACK FOOTER //
// ./src/components/Model/widgetAttr/foreignKey.js